
const GridContainer = ({ children }) => {
  return (
    <div className="relative grid w-full h-full grid-cols-4 gap-4 px-8 pb-12 md:grid-cols-12 md:px-16 lg:px-24">
      {children}
    </div>
  )
}

export default GridContainer